import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { InstitutionsSliderListComponent } from './institutions-slider-list/institutions-slider-list.component';
import { InstitutionsSliderCreateComponent } from './institutions-slider-create/institutions-slider-create.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-page',
        component: InstitutionsSliderListComponent,
        data: {
          title: "List Page",
          breadcrumb: "List Page"
        }
      },
      {
        path: 'create-page',
        component: InstitutionsSliderCreateComponent,
        data: {
          title: "Create Page",
          breadcrumb: "Create Page"
        }
      },
      {
        path: 'institutions-slider-create/:id',
        component: InstitutionsSliderCreateComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class InstitutionsSliderRoutingModule { }
